<template>
    <div class="bar_config chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">半径</span>
            <el-input v-model="radar.radius" @change="getRender" type="number" min="10"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">面积占比</span>
            <el-input v-model="radar.proportion" @change="getRender" type="number" min="1" max="2"
                      step="0.1"></el-input>
            <div class="unit">%</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">起始角度</span>
            <el-input v-model="radar.startAngle" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">底面形状</span>
            <el-select v-model="radar.shape" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">交线颜色</span>
            <el-color-picker v-model="radar.axisLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">分割段数</span>
            <el-input v-model="radar.splitNumber" @change="getRender" type="number"></el-input>
            <div class="unit">层</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">割线颜色</span>
            <el-color-picker v-model="radar.splitLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">割线宽度</span>
            <el-input v-model="radar.splitLine.lineStyle.width" @change="getRender" type="number"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">割线类型</span>
            <el-select v-model="radar.splitLine.lineStyle.type" placeholder="请选择位置"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineStyleList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">底板颜色</span>
            <el-select v-model="radar.splitArea.areaStyle.colorName" placeholder="请选择颜色"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in splitAreaAreaStyleColor"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="radar.name.show" @change="getRender">是否展示字体</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="radar.name.textStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="radar.name.textStyle.fontSize" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">背景颜色</span>
            <el-color-picker v-model="radar.name.textStyle.backgroundColor" show-alpha
                             @change="getRender"></el-color-picker>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'bar_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                typeList: [{name: '多边形', value: 'polygon'}, {name: '圆形', value: 'circle'}],
                lineStyleList: [{name: '实线', value: 'solid'}, {name: '虚线', value: 'dashed'},{name: '点线', value: 'dotted'}],
                splitAreaAreaStyleColor: [
                    {
                        name: "蓝色系",
                        colorList: ['rgba(114, 172, 209, 0.2)', 'rgba(114, 172, 209, 0.4)', 'rgba(114, 172, 209, 0.6)',
                            'rgba(114, 172, 209, 0.8)', 'rgba(114, 172, 209, 1)']
                    },
                    {
                        name: "红色系",
                        colorList: ['rgba(255,35,0,0.2)', 'rgba(255,95,51,0.4)', 'rgba(255,95,51,0.6)',
                            'rgba(255,95,51,0.8)', 'rgb(255,95,51)']
                    },
                    {
                        name: "无",
                        colorList: ['rgba(255,35,0,0)', 'rgba(255,95,51,0)', 'rgba(255,95,51,0)',
                            'rgba(255,95,51,0)', 'rgb(255,95,51,0)']
                    },
                ]
            }
        },
        computed: {
            // radar
            radar() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params.radar;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params.radar;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        watch: {
            "radar.splitArea.areaStyle.colorName"() {
                this.splitAreaAreaStyleColor.map((val) => {
                    if (val.name === this.radar.splitArea.areaStyle.colorName) {
                        this.radar.splitArea.areaStyle.color = val.colorList;
                        this.getRender();
                    }
                })
            }
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .bar_config {

    }
</style>
